export type ParkingCityItem = {
  id: string;
  name: string;
};

const parseCityValue = (value: unknown): string | null => {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.length ? trimmed : null;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return String(value);
  }
  return null;
};

const extractCityArray = (payload: unknown, depth = 0): unknown[] | null => {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (!payload || typeof payload !== "object" || depth > 3) {
    return null;
  }
  const record = payload as Record<string, unknown>;
  const candidates = [
    record["_data_"],
    record._data_,
    record.data,
    record.cities,
    record.list,
    record.results,
    record.items,
  ];
  for (const candidate of candidates) {
    if (!candidate || candidate === payload) {
      continue;
    }
    const extracted = extractCityArray(candidate, depth + 1);
    if (extracted) {
      return extracted;
    }
  }
  return null;
};

const normalizeCityEntry = (entry: unknown): ParkingCityItem | null => {
  if (!entry || typeof entry !== "object") {
    return null;
  }
  const record = entry as Record<string, unknown>;
  const nameCandidate = parseCityValue(record.name ?? record.city ?? record.label);
  const idCandidate = parseCityValue(record.id ?? record.city_id ?? record.cityId ?? record.code ?? record.city);
  const name = nameCandidate ?? idCandidate;
  const id = idCandidate ?? nameCandidate;

  if (!id || !name) {
    return null;
  }

  return {
    id,
    name,
  };
};

export const normalizeCityListResponse = (payload: unknown): ParkingCityItem[] => {
  const source = extractCityArray(payload);
  if (!source) {
    return [];
  }
  return source
    .map((entry) => normalizeCityEntry(entry))
    .filter((entry): entry is ParkingCityItem => Boolean(entry));
};
